<template>
    <Transition>
        <div ref="toast" class="toast">
            <div class="toast__content">
                <div :class="['toast__icon-wrapper', iconClass]">
                    <Icon :icon="icon" />
                </div>
                <div class="toast__content-wrapper">
                    <div v-show="title.length" class="toast__title">
                        {{ title }}
                    </div>
                    <div
                        v-show="message.length"
                        v-html="message"
                        class="toast__text"
                    ></div>
                </div>
            </div>
            <div
                class="toast__dismiss"
                @click="onClose"
                v-if="type !== 'progress'"
            >
                {{ action?.label ? action.label : textOnClose }}
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import Icon from './Icon.vue';
import { computed, ref } from 'vue';

const props = defineProps({
    type: { type: String, default: 'success' }, // success, info, error
    textOnClose: { type: String },
    message: { type: String, default: '' },
    title: { type: String, default: '' },
    action: { type: Object, default: undefined }, // { label, callback }
    duration: { type: Number }
});

const toast = ref<Element | null>(null);

const onClose = () => {
    if (props.action?.label) {
        props.action?.callback();
    } else {
        toast.value?.parentElement?.remove();
    }
};

const icon = computed(() => {
    if (props.type === 'success') {
        return 'CheckboxCheckedDoutone';
    } else if (props.type === 'progress') {
        return 'Loader';
    } else if (props.type === 'error') {
        return 'BanDuotone';
    } else if (props.type === 'info') {
        return 'TriangleWarningDuotone';
    }
});

const iconClass = computed(() => {
    if (props.type === 'success') {
        return '-success';
    } else if (props.type === 'info') {
        return '-info';
    } else if (props.type === 'progress') {
        return '-progress';
    } else {
        return '-error';
    }
});
</script>
<style lang="scss" scoped>
@import '../assets/styles/_main.scss';

.toast {
    display: flex;
    height: max-content;
    border-radius: 10px;
    border: 1px solid $border;
    @include shadow-small;

    position: fixed;
    right: 24px;
    bottom: 24px;
    background-color: $card-background;
    z-index: 120;

    max-width: calc(100vw - 48px);

    &__content {
        display: flex;
        align-items: center;
        padding: 10px 12px;
        gap: 8px;

        &-wrapper {
            display: flex;
            flex-direction: column;
            max-width: 350px;
        }
    }

    &__title {
    }

    &__text {
        @include fz-14;
        font-weight: 500;
        color: $text-high-emphasis;
    }

    &__icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
    }

    &__dismiss {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 88px;
        border-left: 1px solid $border;
        cursor: pointer;

        @include fz-14;
        font-weight: 500;
        color: $text-high-emphasis;
    }
}

.v-enter-active,
.v-leave-active {
    @include transition-default(opacity);
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
